import { FormControl } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { FormLaudoComponent } from '../form-laudo.component';
import { LaudoInput } from 'src/app/models/laudo-input';

export const naoAplicarGrupoSemelhante = (element:LaudoInput, values:any[], parent:FormLaudoComponent) => {
    const naoAplicavelValue = 'nao_aplica';
    const control = element.control as FormControl;
    const controlGroupName = values.map( (r:string) => r.split('|') );

    
    control.valueChanges.pipe(distinctUntilChanged()).subscribe(v => {
        let self = controlGroupName.find(g => g[0] == element.name)
        let others = controlGroupName.filter(g => g != self );

        if(v == '') {
            controlGroupName.forEach( g => g.forEach((c, i) => {
                let control = parent.step.form.get(c);
                if(control) {
                    control.enable();
                    if (i===0) {
                        control.patchValue('');
                    }
                }
            }))
        }

        if(v != '' && v!=naoAplicavelValue ) {
            others.forEach( g => g.forEach((c, i) => {
                let control = parent.step.form.get(c);
                if(control) {
                    if(i>0) {
                        control.disable();
                    } else {
                        control.patchValue(naoAplicavelValue );
                    }
                }
            }))

            self.forEach(c => {
                let control = parent.step.form.get(c);
                if(control) {
                    control.enable();
                }
            });
        }

        if(v == naoAplicavelValue ) {
            let naoAplicaveis = controlGroupName.filter( g => {
                let control = parent.step.form.get(g[0]);
                if(control) {
                   return (control.value == naoAplicavelValue )        
                } else {
                    return true;
                }
            })

            if(naoAplicaveis.length == controlGroupName.length) {
                controlGroupName.forEach( g => g.forEach((c, i) => {
                    let control = parent.step.form.get(c);
                    if(control) {
                        control.enable();
                        if (i===0) {
                            control.patchValue('');
                        }
                    }
                }))
            }
        }
    })
}
